<template>
<div class="job-costing-drill-through-main">
  <!-- Top bar showing filter selections -->
  <div class="filtered-section" id="filtered-section">
    <!-- first column -->
    <div class="filtered-items">

      <div class="filtered-row">
        <div class="filter-title">{{getDateFieldInfo}}</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{fromDate}} to {{toDate}}</div>
      </div>

      <div class="filtered-row">
        <div class="filter-title">As At Date</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{asAtDate}}</div>
      </div>

       <div class="filtered-row">
        <div class="filter-title">Group By</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{getAnalysisType}}</div>
      </div>

      <div class="filtered-row">
        <div class="filter-title">Job Status</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{getJobStatus}}</div>
      </div>
    </div>
    <!-- Second Coloumn -->
     <div class="filtered-items">
      <div class="filtered-row">
        <div class="filter-title">G/L Acc</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{getGlAcc}}</div>
      </div>

      <div class="filtered-row">
        <div class="filter-title">Charge Code</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{getChargeCode}}</div>
      </div>
      
      <div class="filtered-row">
        <div class="filter-title">Job Type</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{getJobType}}</div>
      </div>

       <div class="filtered-row">
        <div class="filter-title">Customer</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{getCustomer}}</div>
      </div>
    </div>

    <div class="refresh-section">
      <div>Last Refreshed : {{refreshDate}}</div>
    </div>
  </div> 
  <div class="drill-through-body" id="drill-through-body">
    <TableBox :dataType="tableDataType" :hideColumns="['#']" :tableData="drillThroughDetails" :title="tableTitle" :loading="tableLoading"/>
  </div>

  <Loader :loadingText="loadText" :isVisbile.sync="loading"/>
</div>
</template>

<script>
/* eslint-disable */
export default {

  components:{},
  data: function(){ 
    return{
      loading: false,
      loadText: 'Getting details...',
      fromDate : '',
      toDate : '',
      asAtDate : '',

      getDateFieldInfo : '',
      getAnalysisType : '',
      getJobStatus : '',
      getJobType : '',
      getGlAcc : '',
      getChargeCode : '',
      getCustomer : '',

      refreshDate : '',
      tableTitle : '',
      drillThroughDetails : [],
      tableLoading : false,
      tableDataType : {},
      fullDetails: null,
    }
  },
  props:{
  },
  methods:{
    getDataFromStorage : async function() {
      this.tableLoading = true;
      const allQuery = this.$route['query'];
      
      if (!allQuery['key']) {
        await this.$showAlert('error', 'No Key', 'Key is not provided', [
          { text: 'Close Window', color: 'indianred', textColor: 'white' }
        ]);
        window.close();
        return;
      }

      let landingURLSessionKeyName = allQuery['key'];
      this.fullDetails = await db.get(landingURLSessionKeyName);
      if (!this.fullDetails) {
        await this.$showAlert('error', 'No Data', 'Data is not available.', [
          { text: 'Close Window', color: 'indianred', textColor: 'white' }
        ]);
        window.close();
        return;
      }
      let landingJSON = this.fullDetails;
      let tempName = landingJSON['chosenMetaLong'].replace(/&amp;/g, '&').trim();
      this.fromDate = landingJSON['fromDate'];
      this.toDate = landingJSON['toDate'];
      this.asAtDate = landingJSON['asAtDate'];
      this.getDateFieldInfo = landingJSON['selectedDateFieldInfo'];
      this.getJobStatus = landingJSON['selectedJobStatusInfo'];
      this.getAnalysisType = landingJSON['selectedAnalysisTypeInfo'];
      this.getGlAcc = landingJSON['getGlAcc'].length == 0 ? 'All' :  landingJSON['getGlAcc'];
      this.getChargeCode = landingJSON['getChargeCode'].length == 0 ? 'All' : landingJSON['getChargeCode'];
      this.getJobType = landingJSON['getJobType'].length == 0 ? 'All' : landingJSON['getJobType'];
      this.getCustomer = landingJSON['getCustomer'].length == 0 ? 'All' : landingJSON['getCustomer'];

      this.refreshDate = landingJSON['lastRefresh'];
      this.tableTitle = landingJSON['title'].includes('All') ? `${landingJSON['title']}` : `${landingJSON['title']} - ${tempName}`;

      this.tableDataType = { // available data type string, number, date, currency
        'Job Date': 'date',
        'Invoice Date': 'date',
        'Amt Billed Excl Tax': 'currency',
        'Tax': 'currency',
        'Cost Excl Tax': 'currency',
        'Gross Profit': 'currency',
        'G. Profit Margin %': 'number',
        'KGM' : 'number',
        'M3' : 'number',
        'Payable' : 'number',
        'Job Not Billed' : 'number',
        'Job Completed' : 'number',
      };
      this.drillThroughDetails = landingJSON['tableData'];
      this.tableLoading = false;
    },		
  },
  async mounted(){
  //  this.loading = true;
    this.$nextTick(() => {
      this.getDataFromStorage();
    })
  }
}
</script>

<style lang="scss" scoped>
  @import '@/css/all.scss';

.job-costing-drill-through-main{
  font-size: 12px;
  padding: 5px 45px;
  /* display: flex; */


  > .filtered-section{
    width: 100%;
    height: 80px;
    background-color: white;
    display: flex;
    align-items: center;
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* position: relative; */

    > .filtered-items{
      width: 100%;
      border-radius: 5px;
      /* display: flex;
      justify-content: space-between; */

      > .filtered-row{
        width: 100%;
        display: flex;
        /* align-items: center; */
        padding-bottom: 3px;

        > .filter-title{
          max-width: 100px;
          min-width: 100px;
          padding-left: 5px;
          /* padding-top: 3px; */
        }

        > .colon-separator{
          margin: 0 5px;
        }
        
        > .filter-details{
          width : 100%;
          padding-left: 3px;
        }
      }

      
    }

    > .refresh-section{
			display: flex;
			width: 100%;
      height: 100%;
			justify-content: flex-end;
			align-items: start;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
      
    }
  }

  > .drill-through-body{
    width: 100%;
    height: calc(100% - 90px);
    background-color: white;
    border-radius: 5px;
    padding: 5px;
  
    
  }

}


</style>